'use strict';

export function absolutePath(path) {
    var Config = require('../config');

    var extraPath = null,
        basePath = getQueryParameter('basePath') || Config.basePath;

    if (path.match(/\.css/) && Config.cssPath) {
        extraPath = Config.cssPath;
    } else if (path.match(/\.js/) && Config.jsPath) {
        extraPath = Config.jsPath;
    } else if (path.match(/\.swf/) && Config.swfPath) {
        extraPath = Config.swfPath;
    } else if (path.match(/\.png|\.jpg/) && Config.imgPath) {
        extraPath = Config.imgPath;
    }

    return basePath + (extraPath ? extraPath + '/' : '') + path;
}

export function getQueryParameter(name, url) {
    var str = url || window.location.search,
        regexp = new RegExp('.*?' + name + '=([^&$]*).*');

    return regexp.test(str) ? str.replace(regexp, '$1') : null;
}

export function setQueryParameters(nameValues, url) {
    var str = url || window.location.search,
        divisor = /\?/.test(str) ? '&' : '?';

    for (var name in nameValues) {
        if (Object.prototype.hasOwnProperty.call(nameValues, name)) {
            if (nameValues[name]) {
                str += (divisor || '&') + name + '=' + nameValues[name];
                divisor = undefined;
            }
        }
    }

    return str;
}



// WEBPACK FOOTER //
// ./src/js/util/url.js